import { useMemo } from "react";
import { ClauseCard } from "../../../components/ClauseCard";
import { useAppData } from "../../../hooks";
import { IClause } from "../../../interfaces";
import { ClauseCardMode } from "../../../types/enums";
import { getKeywords } from "./helpers";

type RenderSuggestionProps = {
  idx: number;
  clause: IClause;
  workspaceId: string;
  appId: string;
  context: any;
};

export const RenderSuggestion = ({ idx, clause, context, workspaceId, appId }: RenderSuggestionProps) => {
  const { searchText, onOpenClauseDocument, unusualPhrases, isKeywordSearch } = context;
  const [footNoteItems] = useAppData<Array<string>>(appId, "footnoteItems");
  const [filters] = useAppData<Record<string, any>>(appId, "filters");
  const searchKeywords = useMemo(() => searchText.split(" "), [searchText]);
  const filterKeywords = useMemo(() => getKeywords(filters?.keywords), [filters]);
  const [redlined] = useAppData<boolean>(appId, "redlined");

  return (
    <div key={idx} style={{ paddingTop: "4px", paddingRight: "5px", paddingLeft: "1px" }}>
      <ClauseCard
        key={clause.clause_id}
        clause={clause}
        isKeywordSearch={isKeywordSearch}
        mode={ClauseCardMode.SUGGESTION}
        unusualPhrases={unusualPhrases[clause.clause_id]}
        searchText={searchText}
        appId={appId}
        onOpenDocument={onOpenClauseDocument}
        workspaceId={workspaceId}
        footNoteItems={footNoteItems}
        searchKeywords={searchKeywords}
        filterKeywords={filterKeywords}
        readlineEnabled={redlined}
      />
    </div>
  );
};
